exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._14ux0{margin:0}.vHI9o{border:0}", ""]);

// exports
exports.locals = {
	"root": "_14ux0",
	"navDropDown": "vHI9o"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/siteadmin/AdminNavigation/AdminNavigation.css
// module id = 2595
// module chunks = 15